import {Injectable} from '@angular/core';
import {HttpServiceBase} from '../core/services/HttpServiceBase';
import {HttpService} from '../core/services/http.service';
import {ProductStructure} from '../core/entities/entities';
import * as _ from 'lodash';
import {ServiceName} from '../core/services/Service';

@Injectable()
export class ProductStructureService extends HttpServiceBase<ProductStructure> {
  getCleanInstance(): ProductStructure {
    return new ProductStructure();
  }

  public hasSingleGet(){
  return false;
}

public refreshOnRouteChange(){
  return false;
}

constructor(protected http: HttpService) {
  super(http);
}

 public fromJson(json): ProductStructure {
    const item: ProductStructure = Object.assign(new ProductStructure(), json);
    if ( json ){
      item.fields = json.fields.map( f => f.field || f);
      item.stockfields = json.stockfields.map( f => f.field || f);
      item.allFields = _.uniq(_.concat(item.fields, item.stockfields));
    }
    return item;
  }

getUrl() {
  return  'productStructure';
}


}

ServiceName.add('ProductStructureService', ProductStructureService);



// WEBPACK FOOTER //
// ./src/app/services/product-structure.service.ts